var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 10.25H15.3125M12.5 13.0625V7.4375",
    stroke: "#979AA8",
    strokeWidth: 2.025,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6125 10.25C21.6125 11.3771 21.0887 12.8005 20.1676 14.3855C19.261 15.9453 18.0381 17.5468 16.7933 19.0011C15.5518 20.4515 14.3074 21.7338 13.3718 22.6546C13.0357 22.9853 12.7402 23.2687 12.5 23.4957C12.2598 23.2687 11.9643 22.9853 11.6282 22.6546C10.6926 21.7338 9.44819 20.4515 8.2067 19.0011C6.96191 17.5468 5.73899 15.9453 4.83242 14.3855C3.91127 12.8005 3.3875 11.3771 3.3875 10.25C3.3875 5.21731 7.46731 1.1375 12.5 1.1375C17.5327 1.1375 21.6125 5.21731 21.6125 10.25Z",
    stroke: "#979AA8",
    strokeWidth: 2.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInspection);
export default __webpack_public_path__ + "static/media/add-inspection.cc8ada1bf4ca05ac807aa82c0768db21.svg";
export { ForwardRef as ReactComponent };